import React, { useEffect, useState } from "react";
import { AuditActionType, IAuditAction } from "../../types/auditActions.type";
import { AuditType } from "../../types/audit.type";
import { api } from "../../api/api";
import {
  DatePicker,
  Input,
  message,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import dayjs from "dayjs";

const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

export default function AuditActions() {
  const [auditActions, setAuditActions] = useState<IAuditAction[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [type, setType] = useState<AuditActionType | null>(null);
  const [auditType, setAuditType] = useState<AuditType | null>(null);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchAuditActions = async () => {
    setLoading(true);

    try {
      const response = await api.get("/audit/actions", {
        params: {
          page,
          limit: pageSize,
          type,
          auditType,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      setAuditActions(response.data.auditActions);
      setTotal(response.data.total);
    } catch (error) {
      console.error(error);
      message.error("Ошибка получений отчёта ревизии");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAuditActions();
  }, [page, pageSize, type, auditType, dateRange]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Тип Ревизии",
      dataIndex: "auditType",
      key: "auditType",
    },
    {
      title: "Пользователь",
      dataIndex: "ownerName",
      key: "ownerName",
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Отчёты ревизий</Title>

      <Space style={{ marginBottom: 16 }}>
        <RangePicker
          onChange={handleRangeChange}
          placeholder={["Начало", "Конец"]}
          format="DD.MM.YY"
          value={dateRange}
        />
        <Select
          allowClear
          placeholder="Фильтр по типу"
          onChange={(value) => setType(value)}
          style={{ width: 200 }}
        >
          {Object.values(AuditActionType).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
        <Select
          allowClear
          placeholder="Фильтр по типу ревизии"
          onChange={(value) => setAuditType(value)}
          style={{ width: 300 }}
        >
          {Object.values(AuditType).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Space>

      <Table
        columns={columns}
        dataSource={auditActions}
        rowKey={(record) => record._id}
        loading={loading}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
